import React from 'react';

const Close = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.3335 1.33337L10.6668 10.6667" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
    <path d="M1.3335 10.6667L10.6668 1.33337" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
  </svg>
);

export default Close;
